module.exports = __webpack_public_path__ + "static/media/conflict.64ee86eb.jpg";